import { createContext, useContext, type Provider } from 'react';

const WidgetVisibilityContext = createContext<boolean>(true);

export const WidgetVisibilityProvider: Provider<boolean> = WidgetVisibilityContext.Provider;

export const useWidgetVisibility = (): boolean => useContext(WidgetVisibilityContext);
